/**
 * Strategy the 1-Klick slot search uses to pick the N earliest slots across the
 * candidate therapists (PRD #928 / RS-006). Sent on
 * `FindEarliestSlotsRequestDto.strategy`; omitted means {@link PREFER_EARLIEST}
 * (the pre-strategy behaviour).
 *
 * - `PREFER_EARLIEST` — soonest N slots regardless of therapist (today's behaviour).
 * - `PREFER_ONE_THERAPIST` — the single therapist who covers all N with the
 *   earliest completion; fewest-therapists fallback when no single full cover
 *   exists. Implemented in RS-007 (#936); RS-006 ships the wire-through routed
 *   to PREFER_EARLIEST behaviour so the toggle is non-erroring before #936 lands.
 */
export var SlotSearchStrategy;
(function (SlotSearchStrategy) {
    SlotSearchStrategy["PREFER_EARLIEST"] = "PREFER_EARLIEST";
    SlotSearchStrategy["PREFER_ONE_THERAPIST"] = "PREFER_ONE_THERAPIST";
})(SlotSearchStrategy || (SlotSearchStrategy = {}));
//# sourceMappingURL=slot-search-strategy.enum.js.map